/* bal-pdp-reviews.js - v4-pdp-said carousel (par pass 2).
   Port of V4PdpSaidReviews.tsx @ bal-com 94cc6d6: fetches the same
   public Judge.me endpoint the Hydrogen PDP used (CORS-open, public
   by design - it is what the Judge.me widget itself calls) and renders
   3 review cards per page with a 4s auto-rotate. */
(function () {
  'use strict';

  var VISIBLE = 3;
  var ROTATE_MS = 4000;
  var MIN_RATING = 5;
  var MIN_BODY_CHARS = 40;

  function stripHtml(html) {
    try {
      var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    } catch (e) {
      return '';
    }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function stars(rating) {
    var wrap = el('span', 'v4-pdp-said__stars');
    var filled = Math.max(0, Math.min(5, Math.round(rating)));
    wrap.setAttribute('aria-label', filled + ' out of 5 stars');
    for (var i = 0; i < 5; i++) {
      var s = el('span', i < filled ? 'v4-pdp-said__star v4-pdp-said__star--on' : 'v4-pdp-said__star', '\u2605');
      s.setAttribute('aria-hidden', 'true');
      wrap.appendChild(s);
    }
    return wrap;
  }

  function reviewCard(review) {
    var card = el('article', 'v4-pdp-said__card');
    card.appendChild(stars(review.rating));
    var title = (review.title || '').trim();
    var body = review.body || '';
    if (title && title.toLowerCase() !== body.toLowerCase()) {
      card.appendChild(el('h3', 'v4-pdp-said__card-title', title));
    }
    card.appendChild(el('p', 'v4-pdp-said__card-body', body || title));
    var meta = el('footer', 'v4-pdp-said__card-meta');
    meta.appendChild(el('span', 'v4-pdp-said__card-author', review.reviewerName));
    if (review.verifiedBuyer) {
      meta.appendChild(el('span', 'v4-pdp-said__card-verified', 'Verified buyer'));
    }
    card.appendChild(meta);
    return card;
  }

  /* RDR-1 (2026-08-21): the rating summary is now server-rendered by
     sections/bal-judgeme-reviews.liquid from the reviews.rating /
     reviews.rating_count metafields, so it is already visible and already
     agrees with the aggregateRating JSON-LD before this script runs. */
  function serverSummary(root) {
    var scope = (root && root.closest) ? root.closest('.v4-pdp-said') : null;
    return (scope || document).querySelector('[data-bal-said-summary]');
  }

  function showFallback(root) {
    root.textContent = '';
    /* With a server-rendered summary on the page the section is NOT broken -
       the rating is visible and schema-consistent. Emitting an outage notice
       there would contradict it, so stay silent and let the summary stand. */
    if (serverSummary(root)) return;
    root.appendChild(el('p', 'v4-pdp-said__fallback', 'Customer reviews are temporarily unavailable. Please check back shortly.'));
  }

  function initSwipe(carousel, onSwipeLeft, onSwipeRight) {
    var startX = 0;
    var startY = 0;
    var tracking = false;
    carousel.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      if (!tracking || !e.changedTouches || !e.changedTouches.length) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) onSwipeLeft();
      else onSwipeRight();
    }, { passive: true });
  }

  function build(root, reviews) {
    var pageCount = Math.max(1, Math.ceil(reviews.length / VISIBLE));
    var page = 0;
    var paused = false;
    var timer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.textContent = '';
    var carousel = el('div', 'v4-pdp-said__carousel');

    /* AUD-11b / D05 (2026-08-19): the summary row renders ONLY the
       Judge.me-sourced values the section passes through from the
       reviews.rating / reviews.rating_count metafields. The old hardcoded
       4.7 / '330+' fallbacks are deliberately GONE: a fabricated aggregate
       here would contradict the aggregateRating JSON-LD the section emits
       from the same metafields (all-or-nothing gate). No attributes, no
       summary row - the review cards still render. The score text shows the
       attribute verbatim so the visible number equals the schema number. */
    var ratingAttr = root.getAttribute('data-display-rating');
    var countAttr = root.getAttribute('data-display-count');
    if (ratingAttr && countAttr && !serverSummary(root)) {
      var summary = el('div', 'v4-pdp-said__summary');
      summary.appendChild(el('span', 'v4-pdp-said__summary-score', ratingAttr));
      summary.appendChild(stars(parseFloat(ratingAttr)));
      summary.appendChild(el('span', 'v4-pdp-said__summary-count', 'Based on ' + countAttr + ' reviews'));
      carousel.appendChild(summary);
    }

    var track = el('div', 'v4-pdp-said__track');
    track.setAttribute('role', 'list');
    track.setAttribute('aria-live', 'polite');
    carousel.appendChild(track);

    var status = null;
    if (pageCount > 1) {
      var nav = el('div', 'v4-pdp-said__nav');
      var prev = el('button', 'v4-pdp-said__nav-btn', '\u2190');
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous reviews');
      status = el('span', 'v4-pdp-said__nav-status');
      var next = el('button', 'v4-pdp-said__nav-btn', '\u2192');
      next.type = 'button';
      next.setAttribute('aria-label', 'Next reviews');
      prev.addEventListener('click', function () { go(page - 1); });
      next.addEventListener('click', function () { go(page + 1); });
      nav.appendChild(prev);
      nav.appendChild(status);
      nav.appendChild(next);
      carousel.appendChild(nav);
    }

    function render() {
      track.textContent = '';
      var start = page * VISIBLE;
      reviews.slice(start, start + VISIBLE).forEach(function (review) {
        var slide = el('div', 'v4-pdp-said__slide');
        slide.setAttribute('role', 'listitem');
        slide.appendChild(reviewCard(review));
        track.appendChild(slide);
      });
      if (status) status.textContent = (page + 1) + ' / ' + pageCount;
    }

    function go(next) {
      page = ((next % pageCount) + pageCount) % pageCount;
      render();
    }

    function tick() {
      if (!paused) go(page + 1);
    }

    carousel.addEventListener('mouseenter', function () { paused = true; });
    carousel.addEventListener('mouseleave', function () { paused = false; });
    carousel.addEventListener('focusin', function () { paused = true; });
    carousel.addEventListener('focusout', function (event) {
      if (!carousel.contains(event.relatedTarget)) paused = false;
    });

    root.appendChild(carousel);
    render();
    if (pageCount > 1) {
      carousel.setAttribute('data-swipeable', 'true');
      initSwipe(
        carousel,
        function () { go(page + 1); },
        function () { go(page - 1); }
      );
    }
    if (pageCount > 1 && !reduceMotion) {
      timer = window.setInterval(tick, ROTATE_MS);
    }
    return timer;
  }

  function boot() {
    var root = document.querySelector('[data-bal-said-carousel]');
    if (!root || !window.fetch) return;
    var shop = root.getAttribute('data-shop-domain');
    var productId = root.getAttribute('data-product-id');
    if (!shop || !productId) return;

    var url = 'https://judge.me/reviews/reviews_for_widget' +
      '?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&platform=shopify&page=1&per_page=24' +
      '&product_id=' + encodeURIComponent(productId) +
      '&sort_by=rating';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('judge.me ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var all = (data && data.reviews ? data.reviews : []).map(function (r, index) {
          return {
            id: r.uuid || 'jdgm-' + index,
            title: (r.title || '').trim(),
            rating: Number(r.rating) || 0,
            body: stripHtml(r.body_html),
            reviewerName: ((r.reviewer_name || 'Customer') + '').trim() || 'Customer',
            verifiedBuyer: Boolean(r.verified_buyer)
          };
        }).filter(function (r) { return r.body || r.title; });

        var best = all.filter(function (r) {
          if (r.rating < MIN_RATING) return false;
          return (r.body || r.title).length >= MIN_BODY_CHARS;
        });
        if (best.length < VISIBLE) {
          best = all.filter(function (r) { return r.rating >= MIN_RATING; });
        }
        if (!best.length) {
          showFallback(root);
          return;
        }
        build(root, best);
      })
      .catch(function () { showFallback(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
